import React from 'react';
import { privacyUrl, calculatorTermsPath } from '../../brand';
import { DISCLAIMER_TEXT } from '../Disclaimer';

// Teal site footer — copyright, legal links, and estimate disclaimer.
// Used on authenticated AppShell views and public marketing/auth pages.
export default function PageFooter({ onShowMethodology, finePrint, bottomInset = 0, legalDocumentVersion }) {
  const disclaimer = finePrint || DISCLAIMER_TEXT;
  return (
    <div
      role="contentinfo"
      style={{ ...footerStyle, paddingBottom: `${32 + bottomInset}px` }}
      data-testid="page-footer"
    >
      <div style={footerInnerStyle}>
        <div>
          <p style={footerCopyrightStyle}>©2026 LooporaData, Inc. All rights reserved.</p>
          {legalDocumentVersion ? (
            <p style={footerVersionStyle} data-testid="footer-legal-document-version">
              Terms version {legalDocumentVersion}
            </p>
          ) : null}
        </div>
        <div style={footerLinksStyle}>
          {onShowMethodology && (
            <button type="button" onClick={onShowMethodology} style={footerLinkBtnStyle}>
              Methodology
            </button>
          )}
          {calculatorTermsPath && (
            <a href={calculatorTermsPath} style={footerLinkAnchorStyle}>Terms</a>
          )}
          <a href={privacyUrl} style={footerLinkAnchorStyle} target="_blank" rel="noopener noreferrer">Privacy</a>
        </div>
      </div>
      <div style={footerFineStyle}>{disclaimer}</div>
    </div>
  );
}

const footerStyle = {
  marginTop: 'auto',
  width: '100%',
  boxSizing: 'border-box',
  background: 'var(--accent)',
  color: '#fff',
  padding: '32px',
};
const footerInnerStyle = {
  maxWidth: '1200px',
  margin: '0 auto',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: '24px',
  flexWrap: 'wrap',
};
const footerCopyrightStyle = {
  margin: 0,
  color: 'rgba(255, 255, 255, 0.92)',
  fontSize: '13px',
};
const footerVersionStyle = {
  margin: '6px 0 0',
  color: 'rgba(255, 255, 255, 0.72)',
  fontSize: '12px',
};
const footerLinksStyle = { display: 'flex', alignItems: 'center', gap: '20px' };
const footerLinkBtnStyle = {
  color: 'rgba(255, 255, 255, 0.88)',
  fontSize: '13px',
  background: 'transparent',
  border: 'none',
  padding: 0,
  cursor: 'pointer',
  fontFamily: 'var(--font)',
};
const footerLinkAnchorStyle = {
  color: 'rgba(255, 255, 255, 0.88)',
  fontSize: '13px',
  textDecoration: 'none',
  fontFamily: 'var(--font)',
};
const footerFineStyle = {
  maxWidth: '1200px',
  margin: '16px auto 0',
  fontSize: '11.5px',
  color: 'rgba(255, 255, 255, 0.72)',
  fontStyle: 'italic',
  lineHeight: 1.5,
};
